const sizeUnits = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];

const formatSize = (bytes?: number | null): string => {
  const byteValue = Number(bytes);

  if (!Number.isFinite(byteValue) || byteValue <= 0) return '0 B';

  const unitIndex = Math.min(
    Math.max(Math.floor(Math.log(byteValue) / Math.log(1024)), 0),
    sizeUnits.length - 1
  );
  const formattedSize = (byteValue / Math.pow(1024, unitIndex)).toFixed(
    unitIndex === 0 ? 0 : 2
  );

  return `${formattedSize} ${sizeUnits[unitIndex]}`;
};

export default formatSize;
